import React, { useEffect, useState, useRef } from "react";
import DetailCard from "../../components/centralMonitorCards/Cards/DetailCard";
//import { handleNotificationEvent } from '../../utils/notificationhandler'
import { connect } from "react-redux";
import keyarData, {
  addKeyarData,
} from "../../redux/features/central_monitor/keyarData";
import { addRealTimeBasicDetail } from "../../redux/features/central_monitor/basic_detail";
import axios from "axios";
import urls from "../../utils/url";
import { useDispatch } from "react-redux";
import { saveAs } from "file-saver";
import Cookie from "js-cookie";
import { isJson } from "../../utils/converter";
import Cookies from "js-cookie";

import CentralGraphLayout from "./central_monitor_graph/CentralGraphLayout";
import BackgroundTimer from "../../utils/backgroundTimer";

const CentralMonitor = ({ addKeyarData }) => {
  const cookie = Cookie.get("access_token");
  const cookieTheme = Cookie.get("theme");
  const hospitalMappingRef = useRef({});

  const [hospitalDetail, setHospitalDetail] = useState(() => {
    const detail = Cookies.get("hospital_detail");
    return detail ? JSON.parse(detail) : null;
  });

  const rawBackendDumpRef = useRef([]);
  const downloadRawBackendJSON = () => {
    const blob = new Blob(
      [JSON.stringify(rawBackendDumpRef.current, null, 2)],
      { type: "application/json" },
    );

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "live-tests-summary-raw.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    window.downloadRawBackendJSON = downloadRawBackendJSON;

    return () => {
      delete window.downloadRawBackendJSON;
    };
  }, []);

  const [prevKeyarData, setPrevKeyarData] = useState([]);
  const [basicDetail, setBasicDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMonitoring, setIsMonitoring] = useState(false);
  const [delay, setDelay] = useState(5000);
  const [fetchDataPerSecsEnum, setfetchDataPerSecsEnum] = useState(5);
  const [currentDelayIndex, setCurrentDelayIndex] = useState(0);
  const [hasReloaded, setHasReloaded] = useState(false);
  const [logs, setLogs] = useState([]);
  const [theme, setTheme] = useState();
  const [minSessionTime, setMinSessionTime] = useState({});
  const [isGraphMode, setIsGraphMode] = useState(false);
  const [isLoadingGraphMode, setIsLoadingGraphMode] = useState(true);

  useEffect(() => {
    if (cookieTheme) {
      setTheme(cookieTheme);
    }
  }, [cookieTheme]);

  useEffect(() => {
    const detail = Cookies.get("hospital_detail");
    setHospitalDetail(detail ? JSON.parse(detail) : null);
  }, []);

  useEffect(() => {
    try {
      const childPlacesCookie = Cookie.get("child_places");

      if (!childPlacesCookie) {
        return;
      }

      let allUserPlaceIDs = [];

      if (childPlacesCookie) {
        const places = JSON.parse(childPlacesCookie);
        allUserPlaceIDs = places.map((p) => Number(p.id));
      }


      const GRAPH_PLACE_IDS = [8340, 8869,5411, 8410, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 8448, 8451, 8445, 8413, 8450, 8494,8495,8496,8501,8503,8498,8528,8445,8453,8446,8447,8449,8451,8500,8502,8504,8505,8506,8507,8509,8511,8512,8516,8517,8502,8454,8455,8456,8457,8499,8508,8514,8515,8518,8519,8522,8521]; // production place ids

      const userHasGraphPlace = GRAPH_PLACE_IDS.some((id) =>
        allUserPlaceIDs.includes(id),
      );


      setIsGraphMode( userHasGraphPlace);

      setIsLoadingGraphMode(false);
    } catch (err) {
      console.warn("❌ Error checking graph mode", err);
      setIsLoadingGraphMode(false);
    }
  }, [hospitalDetail]);

  const handleNotificationEvent = (e) => {
    const dataContent = JSON.parse(e.data.payload.content);
    //console.log(dataContent)
    if (dataContent.type == "patient_keyar_data") {
      if (
        e.data.payload != null &&
        e.data.payload != undefined &&
        dataContent !== null &&
        dataContent != undefined
      ) {
        let data = JSON.parse(e.data.payload.content);
        if (data.content.message == "keyar_test_started") {
          setTimeout(() => {
            setIsMonitoring(true);
          }, fetchDataPerSecsEnum * 1000);
        }
      }
    }
  };

  // useEffect(() => {
  //   fetchEnum()
  // },[])

  // useEffect(() => {
  //   // Skip API calls on localhost - mock data will be used instead
  //   if (isLocal) {
  //     console.log("Localhost detected - skipping API calls in CentralMonitor");
  //     return;
  //   }

  //   let intervalId;
  //   fetchLatestKeyarData()

  //   if (isMonitoring){
  //     intervalId = setInterval(fetchLatestKeyarData, 10000);
  //   }
  //   return () => clearInterval(intervalId);

  // },[isMonitoring, isLocal])

  // useEffect(() => {
  //     // Skip API calls on localhost
  //     if (isLocal) {
  //       return;
  //     }

  //     if (!isMonitoring) {
  //       const timerId = setTimeout(fetchLatestKeyarData, delay);
  //       return () => clearTimeout(timerId);
  //     }
  //   }, [isMonitoring, delay, currentDelayIndex, isLocal]);
  
  useEffect(() => {
    try {
      const childPlacesCookie = Cookie.get("child_places");

      if (childPlacesCookie) {
        const places = JSON.parse(childPlacesCookie);

        const mapping = {};
        places.forEach((place) => {
          mapping[String(place.id)] = {
            name: place.name || "",
            logo: place.logo || null,
          };
        });

        hospitalMappingRef.current = mapping;
      }
    } catch (err) {
      console.error("Failed to load hospital mapping", err);
    }
  }, []);

  useEffect(() => {
    // 🕒 Use a Web Worker timer to prevent throttling in background tabs.
    // Falls back to fetchDataPerSecsEnum (default 10s) while monitoring.
    const intervalMs = isMonitoring ? 10000 : delay;
    const timer = new BackgroundTimer(intervalMs, fetchLatestKeyarData);

    timer.start();

    return () => timer.stop();
  }, [isMonitoring, delay]);

  const fetchLatestKeyarData = async () => {
    const startTime = new Date();
    let placeIdsToUse = [];

    try {
      const childPlacesCookie = Cookie.get("child_places");

      if (childPlacesCookie) {
        const places = JSON.parse(childPlacesCookie);
        placeIdsToUse = places.map((p) => Number(p.id));
      }

      if (placeIdsToUse.length === 0) {
        console.warn("No child places found → skipping API");
        return;
      }

      const placeQuery = placeIdsToUse.join(",");

      const res = await axios.get(
        `${urls.BETA_URL}v1/tesla/live-tests-summary/?place_ids=${placeQuery}`,
        {
          headers: {
            "Request-ID": "allow|me",
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookie}`,
          },
        },
      );

      const json_data = isJson(res.data);
      const data = json_data.response;

      rawBackendDumpRef.current.push({
        fetched_at_local: new Date().toLocaleString("en-IN", { hour12: false }),
        fetched_at_epoch: Date.now(),
        response: data,
      });

      if (rawBackendDumpRef.current.length > 1000) {
        rawBackendDumpRef.current.shift();
      }

      if (data.live_tests) {
        Object.values(data.live_tests).forEach((patient, idx) => {
          // console.log(`Patient ${idx}:`, patient.patient_name);
          if (patient.keyar_data_sets && patient.keyar_data_sets[0]) {
            // console.log(
            //   "  keyar_params available:",
            //   patient.keyar_data_sets[0].keyar_params.map(
            //     (p) => p.param_type || p.param
            //   )
            // );
          }
        });
      }

      if (data && data.live_tests == undefined) {
        updateDelay();
        setIsMonitoring(false);
        addKeyarData([]);
        setMinSessionTime({});
      } else {
        setIsMonitoring(true);
        resetDelay();
        const patient_keyar_data = data.live_tests;

        const keyar_data = Object.values(patient_keyar_data).map((obj) => {
          if (!obj.keyar_data_sets || obj.keyar_data_sets.length === 0) {
            console.error(
              `Missing keyar_data_sets for patient: ${obj.patient_name}`,
            );
            return null;
          }
          const sessionTime = obj.keyar_data_sets[0].data_time;

          const prevMinTime =
            minSessionTime[obj.patient_name] ?? Number.MAX_SAFE_INTEGER;

          const updatedMinTime = Math.min(prevMinTime, sessionTime);

          setMinSessionTime((prevMinTimes) => ({
            ...prevMinTimes,
            [obj.patient_name]: updatedMinTime,
          }));

          const placeId = obj.keyar_data_sets[0].place_id;
          const hospitalInfo = hospitalMappingRef.current[placeId] || {
            name: "",
            logo: null,
          };
          const patientName =
            obj.patient_name ||
            obj.keyar_data_sets[0]?.patient_name ||
            `Patient ${obj.keyar_data_sets[0].patient_id}`;

          return {
            patientName,
            keyarData: obj.keyar_data_sets[0].keyar_params,
            patientID: obj.keyar_data_sets[0].patient_id,
            session_time: updatedMinTime,
            place_id: placeId,
            hospitalName: hospitalInfo.name,
            hospitalLogo: hospitalInfo.logo,
          };
        });

        const cleanedKeyarData = keyar_data.filter(Boolean);
        // console.log(`fetchLatestKeyarData: cleanedKeyarData.length=${cleanedKeyarData.length}`);
        if (cleanedKeyarData.length === 0) {
          console.warn(
            "CentralMonitor: no valid keyar_data entries found in API response",
          );

          if (!window.__centralMonitorRetryScheduled) {
            window.__centralMonitorRetryScheduled = true;
            // console.log('CentralMonitor: scheduling one retry fetch in 1500ms');
            setTimeout(() => {
              fetchLatestKeyarData();
            }, 1500);
          }
        }
        addKeyarData(cleanedKeyarData);
      }
    } catch (err) {
      setMinSessionTime({});

      updateDelay();
      setLoading(false);
    }
  };

  const updateDelay = () => {
    const delaysInSecs = [
      5,
      5,
      10,
      15,
      30,
      60,
      2 * 60,
      5 * 60,
      10 * 60,
      15 * 60,
      30 * 60,
      60 * 60,
    ];
    let nextDelayIndex = currentDelayIndex + 1;

    if (nextDelayIndex >= delaysInSecs.length) {
      nextDelayIndex = delaysInSecs.length - 1;
    }

    setCurrentDelayIndex(nextDelayIndex);
    const nextDelay = delaysInSecs[nextDelayIndex] * 1000;
    setDelay(nextDelay);
  };

  const resetDelay = () => {
    setDelay(5000);
    setCurrentDelayIndex(0);
  };

  //console.log(logs)

  const exportLogs = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," + logs.map((e) => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    saveAs(encodedUri, "logs.csv");
  };

  const fetchEnum = async () => {
    await axios
      .get(
        `${urls.BETA_URL}tesla/app-enums/?source_app=Daksh&categories=keyar&`,
        {
          headers: {
            "Request-ID": "allow|me",
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookie}`,
          },
        },
      )
      .catch((err) => {
        console.log("Enum API Failed", err);
        //fetchLatestKeyarData()
        setLoading(false);
        //setError("Invalid Credentials")
        //setIsLoading(false)
      });
  };

  navigator.serviceWorker.onmessage = (e) => {
    handleNotificationEvent(e);
  };

  // console.log(keyar_data)

  //     return(
  //       <div style={{background: '#0E0E0E',  margin: 0, padding: 0, height:`100vh`}}>
  //  <DetailCard />
  //       </div>
  //     )

  // CMS - CHANGE
  return (
    <div
      style={{
        background:
          theme === "light-theme" && isGraphMode ? "#E8E8E8" : "#0E0E0E",
        margin: 0,
        padding: 0,
        height: `100vh`,
      }}
    >
      {/* {console.log("🔍 Rendering: ", isGraphMode ? "CentralGraphLayout" : "DetailCard", " | isGraphMode =", isGraphMode)} */}
      {isGraphMode ? <CentralGraphLayout /> : <DetailCard />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  keyarData: state.keyarData.keyarData,
  liveBasicDetail: state.liveBasicDetail.liveBasicDetail,
});

const mapDispatchToProps = {
  addKeyarData,
  addRealTimeBasicDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(CentralMonitor);
